import {
  type FieldValues,
  type UseFormReturn,
  useFormContext
} from 'react-hook-form'

/**
 * FormProvider が無い場合に undefined を返す安全ラッパー。
 * ヘッダーなど共通コンポーネントを FormProvider 外で描画してもクラッシュしないようにするために使う。
 */
export const useOptionalFormContext = <T extends FieldValues>():
  | UseFormReturn<T>
  | undefined => {
  try {
    return useFormContext<T>()
  } catch {
    return undefined
  }
}
